document.addEventListener('DOMContentLoaded', function() {
  console.log("document Loaded - Generalized Variant Toggle - Modified for Link Updating");
  // --- URL Extraction & Option Mapping ---

// 1. Get current URL's search parameters
const urlParams = new URLSearchParams(window.location.search);

// 2. Extract and decode the options
const option1 = urlParams.get('option1'); // e.g., "585 GG"
const option2 = urlParams.get('option2'); // e.g., "Singapurkette"

// 3. Define the mapping logic for variant selection
const optionsToSelect = [
    // option1 maps to 'Farbe'. Assuming '585 GG' should select 'Gold'.
    { name: 'Farbe', value: option1 }, 
    
    // option2 maps directly to 'Kette'.
    { name: 'Kette', value: option2 } 
];

// --- Variant Selection Function ---

/**
 * Selects an available variant radio option.
 * @param {string} name - The radio group name (e.g., 'Farbe').
 * @param {string} value - The radio button value (e.g., 'Gold').
 */
function selectVariantOption(name, value) {
    if (!name || !value) return;
    
    // Select the radio input by name and value
    const selector = `input[type="radio"][name="${name}"][value="${value}"]`;
    const targetInput = document.querySelector(selector);

    if (targetInput && !targetInput.disabled) {
        targetInput.checked = true;
        // Trigger change event for e-commerce logic
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        console.log(`✅ Selected: ${name} -> ${value}`);
    } else {
        console.log(`❌ Not selected (missing or unavailable): ${name} -> ${value}`);
    }
}

// --- Execution ---

// Loop through the mapped options and attempt selection
optionsToSelect.forEach(option => {
    selectVariantOption(option.name, option.value);
});


  if (!customElements.get("custom-variant-toggle")) {
    customElements.define(
      "custom-variant-toggle",
      class CustomVariantToggle extends HTMLElement {
        constructor() {
          super();
          // Select all radio inputs inside all fieldsets within this component
          this.variantRadios = this.querySelectorAll('fieldset input[type="radio"]');
          // NEW: Select all product-var-link elements
          this.productVarLinks = this.querySelectorAll('.product-var-link'); 
        }

        variantIdChangedUnsubscriber = undefined;

        connectedCallback() {
          // Listen for radio button changes on all variant inputs
          this.variantRadios.forEach((radio) => {
            radio.addEventListener("change", this.onVariantChange.bind(this)); 
          });

          // On load, update the links based on currently checked radios
          this.setInitialStateAndURL(); 
          
          // Subscribe to variant change pub/sub (If another element changes the variant)
          if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            this.variantIdChangedUnsubscriber = subscribe(
              PUB_SUB_EVENTS.variantChange,
              (event) => {
                console.log("Global variant changed:", event.data.variant);
                
                // 🚀 MODIFIED: Call updateProductLinks with the received variant object
                this.updateProductLinks(event.data.variant);
              }
            );
          }
        }

        disconnectedCallback() {
          // Clean up event listeners
          this.variantRadios.forEach((radio) => {
            // Note: .bind(this) creates a new function reference each time, 
            // the cleanup method here is technically flawed in the original code, 
            // but we'll stick to the original structure for minimum change.
            radio.removeEventListener("change", this.onVariantChange.bind(this)); 
          });

          if (this.variantIdChangedUnsubscriber) {
            this.variantIdChangedUnsubscriber();
          }
        }
        
        /**
         * Checks URL for variant parameters (option1, option2...) and selects radios.
         * Then updates the PRODUCT LINKS to reflect the final state.
         * The original URL synchronization via history.replaceState is REMOVED.
         */
        setInitialStateAndURL() {
            // We keep the URL checking part to set the initial radio state
            const urlParams = new URLSearchParams(window.location.search);
            
            // Map option names to their index (Option1, Option2, etc.) for URL checking
            const optionNames = Array.from(new Set(Array.from(this.variantRadios).map(radio => radio.name)));
            
            optionNames.forEach((name, index) => {
                const paramKey = `option${index + 1}`; // option1, option2
                const urlValue = urlParams.get(paramKey);
                
                if (urlValue) {
                    const matchingRadio = Array.from(this.variantRadios).find(
                        (radio) => radio.name === name && radio.value.toLowerCase() === urlValue.toLowerCase()
                    );
                    
                    if (matchingRadio && !matchingRadio.checked) {
                        matchingRadio.checked = true;
                    }
                }
            });

            // Ensure Product Links reflect the currently checked state
            this.updateProductLinks();
            
            // Original URL update is REMOVED
        }

        /**
         * The core MODIFIED function: Updates the HREFs of links with class 'product-var-link'.
         * The original functionality of updating the browser's URL is REMOVED.
         * @param {Object} [variantObject] - Optional variant object from a global event.
         */
        updateProductLinks(variantObject) {
          
            let optionsToAppend = [];
            
            // 1. Determine the source of the options (Variant object or radio buttons)
            if (variantObject && variantObject.options && Array.isArray(variantObject.options)) {
                // A. Use options from the provided variant object
                optionsToAppend = variantObject.options;
                console.log("Using options from variant object for links:", optionsToAppend);
                
            } else {
                // B. Use options from the currently checked radio buttons (e.g., from a user click)
                const checkedRadios = Array.from(this.querySelectorAll('fieldset input[type="radio"]:checked'));
                
                // Get the order of variant names from the HTML to ensure correct option1, option2 mapping
                const variantNamesInOrder = Array.from(this.querySelectorAll('fieldset')).map(fieldset => 
                    fieldset.querySelector('legend') ? fieldset.querySelector('legend').textContent.trim() : null
                ).filter(name => name);
                
                // Map radio buttons to their corresponding index in the HTML structure
                optionsToAppend = variantNamesInOrder.map(name => {
                    const checked = checkedRadios.find(radio => radio.name === name);
                    return checked ? checked.value : null; // Use null if a variant group isn't selected
                }).filter(option => option !== null); 
                
                console.log("Using options from checked radios for links:", optionsToAppend);
            }

            // 2. Build the new query string
            const newSearchParams = new URLSearchParams();
            optionsToAppend.forEach((value, index) => {
                // Ensure value is properly URL encoded
                newSearchParams.set(`option${index + 1}`, value); 
            });
            const queryString = newSearchParams.toString();


            // 3. Update the href of all relevant links
            this.productVarLinks.forEach((link) => {
                const linkUrl = new URL(link.href);

                // Clear any existing variant parameters on the link's URL
                let i = 1;
                while (linkUrl.searchParams.has(`option${i}`) || i < 5) { 
                    linkUrl.searchParams.delete(`option${i}`);
                    i++;
                }

                // Append the new query string
                if (queryString) {
                    // This is slightly simpler than iterating: replace the search part entirely
                    linkUrl.search = `?${queryString}`; 
                } else {
                    linkUrl.search = ''; // Remove all search parameters if no options are selected
                }

                link.href = linkUrl.toString();
            });
            
            console.log("Product links updated with new options.");
        }


        onVariantChange(event) {
          console.log(`Variant option changed locally: ${event.target.name} = ${event.target.value}`);
          
          // MODIFIED: Update the PRODUCT LINKS instead of the browser URL
          this.updateProductLinks(); 
        }
      }
    );
  }
});